import React, { useEffect, useState } from 'react'
import PhasesStatesStyled from './styled'
import Phases from '../../organism/phases/view'
import Status from '../../organism/status/view'
import BoxSelectionFunnel from './../../molecules/box-selection-funnel/index'

const PhasesStates = ({ classes, i18n }) => {
  const [allPhasesData, setAllPhasesData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (allPhasesData) {
      setIsLoading(false)
    }
  }, [allPhasesData])

  return (
    <>
      <div className={classes.root}>
        <PhasesStatesStyled>
          <div className="containerHeader">
            <div className="sectionFirstText">
              <h2>{i18n.drawer.phases_states}</h2>
              <h5>{i18n.phases_states.descriptionPhasesStates}</h5>
            </div>
            <div className="containerSection">
              <Phases i18n={i18n} setAllPhasesData={setAllPhasesData} />
              {!isLoading && <Status i18n={i18n} allPhasesData={allPhasesData} />}
            </div>
            <div className="containerFunnel">{!isLoading && <BoxSelectionFunnel i18n={i18n} allPhasesData={allPhasesData} />}</div>
          </div>
        </PhasesStatesStyled>
      </div>
    </>
  )
}

export default PhasesStates
